import { ListItemButton, ListItemText } from '@mui/material'

import { ArrowIcon } from 'src/assets/icons'

import { useStyles } from './styles'

interface IProps {
  handleNavigate: () => void
  primary: string
}

export const Button = ({ handleNavigate, primary }: IProps) => {
  const classes = useStyles()

  return (
    <ListItemButton className={classes.item} onClick={handleNavigate}>
      <ListItemText primaryTypographyProps={{ className: classes.itemText }} primary={primary} />
      <ArrowIcon />
    </ListItemButton>
  )
}
